import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { NUMBER_12 } from '~shared/constants';
import { SPONSORING_POSITION, SponsoringPosition } from '~app/modules/storyblok/models';

@Component({
  selector: 'app-sponsoring-tooltip',
  templateUrl: './sponsoring-tooltip.component.html',
  styleUrls: ['./sponsoring-tooltip.component.scss'],
})
export class SponsoringTooltipComponent implements OnChanges, OnDestroy {
  @Input() position: SponsoringPosition;
  @Input() isMobile: boolean = false;
  @Input() width: number = NUMBER_12;
  @Input() height: number = NUMBER_12;
  @Input() fontSize: number = NUMBER_12;
  @Input() tooltipTextColor: string = '#002866';
  @Input() tooltipBackgroundColor: string = '#FFFFFF';
  @Input() bulletTextColor: string = '#FFFFFF';
  @Input() bulletBackgroundColor: string = '#667284';
  @Input() bulletIconName: string;
  @Input() customText?: string;
  @Input() textColor: string = '#667284';
  @Input() textHoverColor: string = '#0064FE';
  @Input() customTooltipHoverBackgroundColor: string = this.textHoverColor;
  @Output() onTooltipHover: EventEmitter<boolean> = new EventEmitter(); // Created for better action visibility (hover)
  @Output() onTooltipClick: EventEmitter<boolean> = new EventEmitter(); // Created for better action visibility (click)
  isVisible: boolean = false;
  positions = SPONSORING_POSITION;

  private destroySubject$: Subject<boolean> = new Subject<boolean>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isMobile'] && this.isMobile && this.isVisible) {
      this.hideTooltip();
    }
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  showTooltip(): void {
    this.isVisible = true;
  }

  hideTooltip(): void {
    this.isVisible = false;
  }

  triggerClickEvent(): void {
    this.onTooltipClick.emit();
  }

  triggerHoverEvent(): void {
    this.onTooltipHover.emit();
  }
}
